import React from 'react';
import { FiShare2, FiShield } from 'react-icons/fi';
import SettingsModal from '../SettingsModal';
import { SocialAccount } from './announcementData';

interface Props {
    accounts: SocialAccount[];
    onConnect: (id: string) => void;
    onDisconnect: () => void;
    onClose: () => void;
}

// X is real (Connect goes to X's sign-in page); LinkedIn is still UI only
const ConnectSocialModal: React.FC<Props> = ({ accounts, onConnect, onDisconnect, onClose }) => {
    const notConnected = accounts.find(a => !a.connected);

    return <SettingsModal icon={<FiShare2 />} title="Connect a Social Account" sub="Investi posts on the company's behalf — it never reads your feed" onClose={onClose}
        footerNote="Whoever connects an account stays as the poster of record." cancelLabel="Done">
        {accounts.map(a => <div key={a.id} className={`account large${a.connected ? '' : ' off'}`}>
            <span className="icon-tile"><FiShare2 /></span>
            <div className="text"><strong>{a.id === 'x' ? 'X (Twitter)' : a.name}</strong><span>{a.id === 'x' && a.connected ? a.detail : a.kind}</span></div>
            {a.connected
                ? <>
                    <span className="badge ok">Connected</span>
                    {a.id === 'x' && <button type="button" className="btn-outline" onClick={onDisconnect}>Disconnect</button>}
                </>
                : <button type="button" className="btn-primary" onClick={() => onConnect(a.id)}>Connect</button>}
        </div>)}
        <div className="modal-note"><FiShield /> {notConnected
            ? `Clicking Connect opens ${notConnected.name} so you can sign in there. Investi only asks for permission to publish posts — it can't see messages or friends.`
            : 'Investi only has permission to publish posts — it can’t see messages or followers.'}</div>
    </SettingsModal>;
};

export default ConnectSocialModal;
